import { css } from '@emotion/css';

export const linkStyles = css`
  width: fit-content;
`;
